import { css, cx } from '@emotion/css';
import React from 'react';
import { selectedItemTextStyles } from '../shared';
import { theme, useThemeContext, getThemeColor, } from '@contrast-security-inc/design-system-foundations';
import { Tooltip } from '@contrast-security-inc/design-system-popovers';
import { useResizeObserver } from '../utils/useResizeObserver';
/**
 * Bring the selection to the front so that the on-hover gets triggered,
 * keep the cursor looking like a button that will open/close the menu
 */
const customSelectedItemStyles = css `
  z-index: 1;
  cursor: pointer;
  user-select: none;
`;
const customDisabledSelectedItemStyles = (selectedTheme) => css `
  color: ${getThemeColor(selectedTheme, { light: theme.color.neutral60, dark: theme.color.neutral40 })};
  cursor: not-allowed;
`;
export const DropdownSelectedItem = ({ itemToString, renderInputValue, testId, isOpen, isDisabled, selectedItem, showOverflowTooltip, ...rest }) => {
    const { selectedTheme } = useThemeContext();
    const { observeRef, dimensions: { isOverflowing }, } = useResizeObserver();
    return showOverflowTooltip ? (React.createElement(Tooltip, { enabled: isOverflowing, ref: observeRef, isDelayed: true, body: itemToString(selectedItem), testId: `${testId}-selected-item-tooltip` },
        React.createElement("span", { ...rest, className: cx('ds-dropdown-input-value', selectedItemTextStyles(false, selectedTheme), customSelectedItemStyles, isDisabled && customDisabledSelectedItemStyles(selectedTheme)), "data-testid": `${testId}-selected-item-input-value` }, renderInputValue ? renderInputValue(selectedItem, !!isOpen) : itemToString(selectedItem)))) : (React.createElement("span", { ...rest, className: cx('ds-dropdown-input-value', selectedItemTextStyles(false, selectedTheme), isDisabled && customDisabledSelectedItemStyles(selectedTheme)), "data-testid": `${testId}-selected-item-input-value` }, renderInputValue ? renderInputValue(selectedItem, !!isOpen) : itemToString(selectedItem)));
};
